var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-section-container"},[_c('MainGrid',_vm._l((_vm.items),function(ref){
var id = ref.id;
var file = ref.file;
var created_at = ref.created_at;
return _c('MainGridItem',{key:id,attrs:{"image":file,"text":created_at,"id":id}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }